import { Box, Button, Grid, ListItem, ListItemButton, ListItemText, Stack, Typography } from "@mui/material";

export default function PlaceholderStUnitListItem({ icon, label, selected, onSelect, disabled }) {
  return (
    <ListItem
      disablePadding
      className={"stUnitListItem" + (selected ? " selected" : "") + (disabled ? " disabled" : "")}
    >
      <ListItemButton disabled={disabled} onClick={onSelect}>
        <ListItemText>
          <Stack direction="row" spacing={2} alignItems="center" paddingTop={1} paddingBottom={1}>
            {icon}
            <Box>{label}</Box>
          </Stack>
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );
}
